import React, { useEffect, useState } from "react";
import { fetchFutureTechVideos } from "../API/API";
import RegisterModal from "../pages/RegisterModal";
import "../styles/FutureTechTraining.css";

const defaultVideos = [
  {
    title: "Data Structure & Algorithm",
    id: "qT2U8TG5u6s",
    link: "https://www.youtube.com/watch?v=qT2U8TG5u6s",
    isDemo: true,
  },
   {
    title: "Data Engineering Playlist",
    id: "Jq7rvvrHejM",
    link: "https://www.youtube.com/watch?v=Jq7rvvrHejM&list=PLfuvcZwtz-hgvP8OdO_ignzkisAR39BG0&index=1",
    isDemo: true,
  },

  {
    title: "Apache Spark Intro",
    id: "gxitrRvyByc",
    link: "https://www.youtube.com/watch?v=gxitrRvyByc",
    isDemo: true,
  },
  {
    title: "Installation Of Apache",
    id: "Vl-ZDO9vyH8",
    link: "https://youtu.be/Vl-ZDO9vyH8",
    isDemo: false,
  },
  {
    title: "Network Analytics",
    id: "PGeBdvgYVNA",
    link: "https://www.youtube.com/watch?v=PGeBdvgYVNA&list=PLfuvcZwtz-hhjIxnLKGMSgxVLOwCIGsob&index=1",
    isDemo: true,
  },
   {
    title: "Python Programming with 10 Years kid",
    id: "6v-f-pk0vNI",
    link: "https://www.youtube.com/watch?v=6v-f-pk0vNI&list=PLfuvcZwtz-hiRAJH66sk4DrJNbVOgN3wU&index=2",
    isDemo: true,
  },
 
];

const FutureTechTraining = () => {
  const [videos, setVideos] = useState([]);
  const [hoveredVideo, setHoveredVideo] = useState(null);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const loadVideos = async () => {
      try {
        const res = await fetchFutureTechVideos();
        if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
          const updated = res.data.map((video, index) => ({
            ...video,
            isDemo: index === 0,
          }));
          setVideos(updated);
        } else {
          setVideos(defaultVideos);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
        setVideos(defaultVideos);
      }
    };

    loadVideos();
  }, []);

  const handleVideoClick = (video) => {
    if (video.isDemo || hasAccess) {
      window.open(video.link, "_blank");
    } else {
      setShowRegisterModal(true);
    }
  };

  const handleTitleClick = (e, video) => {
    e.stopPropagation();
    if (video.isDemo || hasAccess) {
      window.open(video.link, "_blank");
    } else {
      setShowRegisterModal(true);
    }
  };

  return (
    <div className="futuretech-container">
      <h1 className="title">FutureTech Videos</h1>

      <div className="video-section">
        <div className="video-grid">
          {videos.map((video, index) => {
            const isRestricted = !video.isDemo && !hasAccess;
            return (
              <div
                key={index}
                className="video-container"
                onMouseEnter={() => setHoveredVideo(video.id)}
                onMouseLeave={() => setHoveredVideo(null)}
                onClick={() => handleVideoClick(video)}
                onDoubleClick={(e) => {
                  if (isRestricted) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                {hoveredVideo === video.id ? (
                  <iframe
                    className="video-frame"
                    src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=1&controls=${isRestricted ? 0 : 1}`}
                    title={video.title}
                    frameBorder="0"
                    allow={isRestricted ? "" : "autoplay; encrypted-media"}
                    allowFullScreen={!isRestricted}
                  ></iframe>
                ) : (
                  <img
                    className="video-thumbnail"
                    src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                    alt={video.title}
                  />
                )}
                <h3
                  className="video-title"
                  onClick={(e) => handleTitleClick(e, video)}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  {video.title} {video.isDemo ? "(Demo)" : ""}
                </h3>
              </div>
            );
          })}
        </div>
      </div>

      {showRegisterModal && (
        <RegisterModal
          onClose={() => setShowRegisterModal(false)}
          onPaymentSuccess={() => {
            setHasAccess(true);
            setShowRegisterModal(false);
          }}
        />
      )}
    </div>
  );
};

export default FutureTechTraining;
